import React from 'react';
import './styles.scss';

export function TachoToolbarHorizontalLine(): JSX.Element {
    return <div className="tachoToolbarHorizontalLine"></div>;
}
